export default "__VITE_ASSET__DJDO4eQj__"